import { createSelector } from 'reselect';
import { functionalCurrencyOption } from '../constants';
import { uniq } from '../../../shared/uniq';
import { ReduxState } from '../../../shared/reduxStateType';
import type { Scenario } from '../../../shared/queries/scenarios';
import { YesNoFlag } from '../../../shared/types';


export const scenariosSelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.scenarios;

export const isLoadingScenariosSelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.isLoadingScenarios;

export const isLoadingCalculatingScenarioSelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.isLoadingCalculatingScenario;

export const scenarioAllowedPeriodsSelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.scenarioAllowedPeriods;

export const scenarioAllowedPeriodsOptionsSelector = createSelector(
  scenarioAllowedPeriodsSelector,
  periods => periods.map(({ periodName }) => ({
    label: periodName,
    value: periodName,
  }))
);

export const isLoadingScenarioAllowedPeriodsSelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.isLoadingScenarioAllowedPeriods;

const getPublicFlagText = ({ publicFlag }: Scenario) => publicFlag === YesNoFlag.Y
  ? 'Public'
  : 'Private';

const getLockedFlagText = ({ lockedFlag }: Scenario) => lockedFlag === YesNoFlag.Y
  ? 'Locked'
  : 'Unlocked';

export const scenariosOptionsSelector = createSelector(
  scenariosSelector,
  scenarios => scenarios.map(scenario => ({
    value: scenario.scenarioId,
    label: `[${scenario.periodName}] [${scenario.dataSource}] ${scenario.scenarioName} [${getPublicFlagText(scenario)}] [${getLockedFlagText(scenario)}]`,
  }))
);

export const selectedScenarioToCompareSelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.selectedScenarioToCompare;

export const selectedScenarioViewSelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.selectedView;

export const selectedScenarioEditCySelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.selectedEditCY;

export const selectedScenarioCurrencySelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.selectedCurrency;

export const currenciesOptionsSelector = () => ([
  functionalCurrencyOption,
  {
    label: 'USD',
    value: 'USD',
  },
]);


const isObject = (arg: unknown): arg is Record<PropertyKey, unknown> => typeof arg === 'object';

export const reportFieldsDefinitionSelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.reportFields;

export const reportsNamesSelector = createSelector(
  reportFieldsDefinitionSelector,
  reportFields => uniq(
    reportFields
      .filter(({ from }) => isObject(from))
      .flatMap(({ from }) => Object.keys(from))
  )
);

export const isLoadingReportFieldsSelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.isLoadingReportFields;

export const isUploadingTaggedDataSelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.isLoadingUploadTaggedData;

export const taggedDataErrorsSelector = ({ scenarios }: ReduxState) =>
  scenarios.shared.uploadTaggedDataErrors;
